module.exports = __webpack_public_path__ + "static/media/tomasz_profile_pic.f9aecead.png";